// © Microsoft Corporation. All rights reserved.

import { DesignSystem, neutralFillHover, neutralForegroundHint, neutralForegroundRest } from "@microsoft/fast-components-styles-msft";

import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";
import { secondaryBorderColor } from "../utils/commonJssConstants";

export const PublisherSubscribeFollowButtonStyles = (config: DesignSystem) => ({
    publisherSubscribeFollowButtonContainer: {
        display: "flex",
        "flex-direction": "row",
        background: "none",
        padding: "8px 16px",
        "font-size": "12px",
        "border-radius": "20px",
        "align-items": "center",
        cursor: "pointer",
        "& .cwt-icon": {
            [applyLocalizedProperty("margin-right", "margin-left", config.direction)]: "10px"
        }
    },
    publisherSubscribeFollowButtonInactiveContainer: {
        border: "1px solid",
        color: "white",
        "border-color": secondaryBorderColor,

        "&:hover": {
            "background-color": neutralFillHover,
            "border-color": neutralForegroundRest,
            color: neutralForegroundHint
        },

        "& .cwt-icon": {
            color: "currentColor"
        }
    },
    publisherSubscribeFollowButtonActiveContainer: {
        color: "#63ADE5",
        border: "none",
        "& .cwt-icon": {
            color: "currentColor"
        }
    }
});